export const plansInformationTableHeader = [
  { header: 'Id', field: 'id' },
  { header: 'Instance Id', field: 'instanceId' },
  { header: 'Sub Domain', field: 'subdomain' },
  { header: 'Created Date', field: 'createdAt' },
  { header: 'status', field: 'state' },
  { header: 'action', field: '' },
];
